import { createSlice } from "@reduxjs/toolkit";

// @ts-ignore
import { formAnswers, lifeStyleFormAnswers } from "./data";
import { NormalizedNutritionV2 } from "../../platform/components/nutritionTab/type";

export interface RootStateAnswers {
  answers: RootStateAnswersObj;
}
export interface RootStateAnswersObj {
  biometricQuest: any;
  lifestyleQuest: any;
  nutritionQuest: NormalizedNutritionV2 | null;
  personalInfoInitialAnswers: any;
  personalInfoAnswers: any;
  personalInfoModifiedFields: string[];
  biometricOldAnswers: any;
  biometricInitialAnswers: {};
  biometric_modified_fields: string[];
  biometric_initial_modified_fields: string[];
}

const initialAnswersState: RootStateAnswersObj = {
  biometricQuest: formAnswers,
  lifestyleQuest: lifeStyleFormAnswers,
  nutritionQuest: null,
  personalInfoInitialAnswers: {},
  personalInfoAnswers: {},
  personalInfoModifiedFields: [],
  biometricOldAnswers: {},
  biometricInitialAnswers: {},
  biometric_modified_fields: [],
  biometric_initial_modified_fields: [],
};

const answersSlice = createSlice({
  name: "answers",
  initialState: initialAnswersState,
  reducers: {
    updateBiometricAnswers(state, action) {
      state.biometricQuest.myAnswers = {
        ...state.biometricQuest.myAnswers,
        ...action.payload,
      };
    },
    updateLifestyleAnswers(state, action) {
      state.lifestyleQuest.myAnswers = {
        ...state.lifestyleQuest.myAnswers,
        ...action.payload,
      };
    },
    updateNutritionAnswers(state, action) {
      state.nutritionQuest = action.payload;
    },
    updateOldBiometricAnswers(state, action) {
      state.biometricOldAnswers = {
        ...action.payload,
      };
    },
    updateInitialBiometricAnswers(state, action) {
      state.biometricInitialAnswers = {
        ...action.payload,
      };
    },
    updateBiometricModifiedFields(state, action) {
      state.biometric_modified_fields = [...(action.payload ?? [])];
    },
    updateInitialBiometricModifiedFields(state, action) {
      state.biometric_initial_modified_fields = [...(action.payload ?? [])];
    },
    addBiometricModifiedFields(state, action) {
      state.biometric_modified_fields = [
        ...state.biometric_modified_fields,
        action.payload,
      ];
    },
    removeBiometricModifiedFields(state, action) {
      state.biometric_modified_fields = state.biometric_modified_fields.filter(
        (el) => el !== action.payload
      );
    },
    updatePersonalInfoInitialAnswers(state, action) {
      state.personalInfoInitialAnswers = {
        ...state.personalInfoInitialAnswers,
        ...action.payload,
      };
    },
    updatePersonalInfoAnswers(state, action) {
      state.personalInfoAnswers = {
        ...state.personalInfoAnswers,
        ...action.payload,
      };
    },
    addPersonalInfoModifiedFields(state, action) {
      state.personalInfoModifiedFields = [
        ...state.personalInfoModifiedFields,
        action.payload,
      ];
    },
    removePersonalInfoModifiedFields(state, action) {
      state.personalInfoModifiedFields =
        state.personalInfoModifiedFields.filter((el) => el !== action.payload);
    },
    clearPersonalInfoModifiedFields(state) {
      state.personalInfoModifiedFields = [];
    },
    clearState(state) {
      Object.keys(state).forEach((key) => {
        // @ts-ignore
        state[key] = initialAnswersState[key];
      });
    },
  },
});

export const answersActions = answersSlice.actions;

export default answersSlice;
